/* eslint-disable */
/**
 * This is autogenerated file by
 * packages/editor-elements-preview-utils/scripts/generateEntries.js script
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bi = require("./src/entries/bi");

Object.keys(_bi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bi[key];
    }
  });
});